import type { FaireProductEntity } from "../../entity_types/product";

export const p_ykwagh58xx: FaireProductEntity = {
  token: "p_ykwagh58xx",
  type: "product",
  name: "Ladies Multiple Evil Eye Themed Tote Handbag",
  brandToken: "b_eungak2r99",
  brandName: "Nima Accessories Inc",
  imageUrl: "https://cdn.faire.com/fastly/a7a833a6768d86bc9e01beeb3990045347db4a2deb8b534820cdcd9540da6fa8.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.09,
  description: "Discover a new style staple with the Ladies Multiple Evil Eye Themed Tote Handbag by Nima Accessories Inc. This tote bag is not just a bag, but a fashion statement that seamlessly blends functionality and style. It is designed to cater to the modern woman's needs, providing ample space without compromising on its chic appeal. Nima Accessories Inc, a renowned name in women's accessories since 1982, presents this tote bag as a part of its latest collection. Experience the blend of fashion-forward design and practicality that Nima Accessories Inc is known for.",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:09.714Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
